import React, { useState, useEffect } from "react";

/**
 * 📌 Carrousels inspirés de l'exemple fourni
 * - 3 sections : Mugs, T-shirts, Tote bags
 * - 1 image visible à la fois, 3 images max par carrousel
 * - Format compact avec coins décorés et légende
 */

const MUGS = [
  { src: "https://public.youware.com/image/7011efe1-64ce-4d24-bb9f-d793105aea43/9nbxgiifom.png", alt: "Mug Octobre Rose" },
  { src: "https://public.youware.com/image/302d44d8-9a8c-4316-9009-07f59040e38b/nhveiofadq.png", alt: "Mug Ruban Rose" },
  { src: "/assets/octobre-rose/mug-3.png", alt: "Mug Hope" }
];

const TSHIRTS = [
  { src: "/assets/octobre-rose/tshirt-1.jpg", alt: "T-shirt Hope" },
  { src: "/assets/octobre-rose/tshirt-2.jpg", alt: "T-shirt Courage" },
  { src: "/assets/octobre-rose/tshirt-3.jpg", alt: "T-shirt Solidarity" }
];

const TOTEBAGS = [
  { src: "/assets/octobre-rose/tote-bag-1.jpeg", alt: "Tote Bag Solidarity" },
  { src: "/assets/octobre-rose/tote-bag-2.jpeg", alt: "Tote Bag Pink Ribbon" },
  { src: "/assets/octobre-rose/tote-bag-3.jpeg", alt: "Tote Bag Hope" }
];

function ImageCarousel({ images, title }) {
  const [index, setIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setIndex((prev) => (prev + 1) % images.length);
    }, 4000);
    return () => clearInterval(interval);
  }, [images.length]);

  const goPrev = () => setIndex((prev) => (prev - 1 + images.length) % images.length);
  const goNext = () => setIndex((prev) => (prev + 1) % images.length);

  return (
    <div className="w-full max-w-[500px] mx-auto">
      <div className="mb-2 flex items-center justify-between">
        <h3 className="text-lg font-semibold tracking-tight">{title}</h3>
      </div>

      <div className="relative rounded-3xl border border-neutral-300 bg-white p-4 shadow-[0_10px_30px_rgba(0,0,0,0.06)]">
        {/* Coins décorés */}
        <span className="pointer-events-none absolute right-6 top-6 h-4 w-4 rounded-sm bg-pink-500" />
        <span className="pointer-events-none absolute left-6 bottom-6 h-3 w-3 rounded-sm bg-neutral-900" />

        {/* Image affichée */}
        <div className="overflow-hidden rounded-2xl border border-neutral-200 aspect-[3/4] flex justify-center items-center min-h-[400px]">
          <img
            src={images[index].src}
            alt={images[index].alt}
            className="h-full w-full object-contain"
            loading={index === 0 ? 'eager' : 'lazy'}
          />
        </div>

        {/* Flèches */}
        <button
          onClick={goPrev}
          className="absolute left-2 top-1/2 -translate-y-1/2 rounded-full bg-neutral-300/90 p-2 shadow hover:bg-neutral-200"
        >
          ‹
        </button>
        <button
          onClick={goNext}
          className="absolute right-2 top-1/2 -translate-y-1/2 rounded-full bg-neutral-300/90 p-2 shadow hover:bg-neutral-200"
        >
          ›
        </button>

        {/* Dots */}
        <div className="mt-3 flex items-center justify-center gap-2">
          {images.map((_, i) => (
            <button
              key={i}
              onClick={() => setIndex(i)}
              className={`h-2 w-2 rounded-full transition-opacity ${i === index ? 'opacity-100' : 'opacity-50'} bg-neutral-700`}
            />
          ))}
        </div>

        {/* Légende */}
        <div className="mt-3 text-center text-[15px] text-neutral-800">
          {images[index].alt}
        </div>
      </div>
    </div>
  );
}

export default function OctobreRosePage() {
  return (
    <section className="w-full py-8">
      <div className="max-w-[500px] mx-auto px-4">
        <h2 className="mb-6 text-2xl font-bold">Octobre Rose — Produits</h2>

        <div className="flex flex-col gap-8">
          <ImageCarousel images={MUGS} title="Mugs" />
          <ImageCarousel images={TSHIRTS} title="T-shirts" />
          <ImageCarousel images={TOTEBAGS} title="Tote bags" />
        </div>
      </div>
    </section>
  );
}